export default __webpack_public_path__ + "static/media/harsh.a0951516.jpg";